import React from 'react';
import styles from './Accordion.module.css';

const Accordion = ({ title, content, isOpen, onClick }) => {
  return (
    <div className={styles.accordion}>
      <div className={styles.accordionTitle} onClick={onClick}>
        {title}
        <span className={styles.symbols}>{isOpen ? '-' : '+'}</span>
      </div>
      <div
        className={isOpen ? styles.accordionContentOpen : styles.accordionContent}
        style={{ whiteSpace: 'pre-wrap' }} // preserves newlines and spaces
      >
        {content}
      </div>
    </div>
  );
};

export default Accordion;
